import type { OfferReduxBaseState } from '../types/offerReduxBaseState';
import { calculateAccessoriesTotalAmount } from '../utils/manualAccessoriesUtils';

export const getAccessories = (state: OfferReduxBaseState) => {
    return state.accessories;
};

export const getAccessoriesList = (state: OfferReduxBaseState) => {
    return getAccessories(state)?.elements || [];
};

export const getAccessoriesTotalAmount = (state: OfferReduxBaseState) => {
    const accessories = getAccessoriesList(state);
    return calculateAccessoriesTotalAmount(accessories) || 0;
};
